import Icon from '../components/Icon.vue'

Icon.register({
  'grip-lines': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 288c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480zM496 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grip-lines.js
// module id = 1414
// module chunks = 0